<template>
  <div>
    <div class="whitePanel marginBottom">
      <div class="grid">
        <div class="col-12 md:col-2">
          <p class="blueText marginB5Px">
            {{ $t("expedientes.label.nReferenciaBorrador") }}
          </p>
          <InputText
            v-model="filters['token']"
            class="input"
            id="token"
            type="text"
            :placeholder="$t('expedientes.placeholders.nReferencia')"
          />
        </div>
        <div class="col-12 md:col-3">
          <p class="blueText marginB5Px">
            {{ $t("expedientes.label.estado") }}
          </p>
          <Dropdown
            v-model="filters['pagado']"
            class="input"
            :options="dropdownPaid"
            optionLabel="name"
            optionValue="code"
            :placeholder="$t('expedientes.placeholders.estadoPagado')"
          />
        </div>
        <div class="col-12 md:col-4" v-if="this.type === reclamacion">
          <p class="blueText marginB5Px">
            {{ $t("expedientes.label.nombreReclamado") }}
          </p>
          <InputText
            v-model="filters['nombreDeudor']"
            class="input"
            id="nombre"
            type="text"
            :placeholder="$t('expedientes.placeholders.nombreReclamado')"
          />
        </div>
        <div class="col-12 md:col-3" v-if="this.type === reclamacion">
          <p class="blueText marginB5Px">
            {{ $t("expedientes.label.nifReclamado") }}
          </p>
          <InputText
            v-model="filters['idLegalDeudor']"
            class="input"
            id="dni"
            type="text"
            :placeholder="$t('expedientes.placeholders.nifReclamado')"
          />
        </div>
        <div class="col-12">
          <div class="flex justify-content-end">
            <Button
              @click="clearFields()"
              label="Limpiar"
              class="buttonStyle rightAlign lightBlueBG"
            />
          </div>
        </div>
      </div>
    </div>
    <DataTable
      :value="drafts.items"
      :loading="loading"
      :lazy="true"
      :paginator="true"
      :rows="tamPagina"
      :totalRecords="drafts.totalElements"
      :filters.sync="filters"
      class="p-datatable-responsive"
      @sort="customSort($event)"
      @page="onPage($event)"
      :autoLayout="true"
    >
      <template #empty>
        {{ $t("expedientes.datatable.noBorradores") }}
      </template>

      <Column
        field="token"
        :header="$t('expedientes.header.nReferencia')"
        :sortable="false"
        headerStyle="width: 7em"
      >
        <template #body="slotProps">
          <span class="column-title">{{
            $t("expedientes.label.nReferencia")
          }}</span>
          {{ slotProps.data.token }}
        </template>
      </Column>
      <Column
        field="fechaModi"
        :header="$t('expedientes.header.fecha')"
        :sortable="true"
        headerStyle="width: 5em"
      >
        <template #body="slotProps">
          <span class="column-title">{{
            $t("expedientes.label.fecha")
          }}</span>
          {{ getFormattedDateShort(slotProps.data.fechaModi) }}
        </template>
      </Column>
      <Column
        v-if="type === 'reclamacion'"
        field="reclamado"
        :header="$t('expedientes.header.reclamado')"
        :sortable="false"
        :headerStyle="headerStyle"
      >
        <template #body="slotProps">
          <span class="column-title">{{
            $t("expedientes.label.reclamado")
          }}</span>
          {{ slotProps.data.deudor }}
        </template>
      </Column>
      <Column
        v-if="type === 'reclamacion'"
        field="acreedor"
        :header="$t('expedientes.header.acreedor')"
        :sortable="false"
        :headerStyle="headerStyle"
      >
        <template #body="slotProps">
          <span class="column-title">{{
            $t("expedientes.label.acreedor")
          }}</span>
          {{ slotProps.data.acreedor }}
        </template>
      </Column>
      <Column
        v-if="type === 'reclamacion'"
        field="totalPendiente"
        :header="$t('expedientes.header.pendiente')"
        :sortable="false"
        :headerStyle="headerStyle"
      >
        <template #body="slotProps">
          <span class="column-title">{{
            $t("expedientes.label.pendiente")
          }}</span>
          {{
            slotProps.data.pendiente
              | toCurrency("es-ES", slotProps.data.divisa)
          }}
        </template>
      </Column>
      <Column
        field="pagado"
        :header="$t('expedientes.header.estado')"
        :sortable="true"
        headerStyle="width: 11em"
      >
        <template #body="slotProps">
          <span class="column-title">{{
            $t("expedientes.label.estado")
          }}</span>
          {{
            slotProps.data.pagado
              ? $t("expedientes.label.pagado")
              : $t("expedientes.label.sinPagar")
          }}
        </template>
      </Column>
      <Column
        field="ficha"
        :header="$t('expedientes.header.ficha')"
        :sortable="false"
        :headerStyle="headerStyle"
        bodyStyle="text-align:center"
      >
        <template #body="slotProps">
          <span class="column-title">{{
            $t("expedientes.label.ficha")
          }}</span>
          <Button
            class="ficha centerButton"
            label="Ver"
            icon="pi pi-chevron-right"
            iconPos="right"
            @click="onDraftClick(slotProps.data)"
          />
        </template>
      </Column>
      <Column
        field="borrar"
        header=""
        :sortable="false"
        bodyStyle="text-align:center"
      >
        <template #body="slotProps">
          <span class="column-title"></span>
          {{ slotProps.data.borrar }}
          <Button
            :disabled="slotProps.data.pagado"
            class="centerButton"
            label=""
            icon="pi pi-trash"
            @click="openDeleteModal(slotProps.data)"
          />
        </template>
      </Column>
    </DataTable>
    <Dialog
      :header="
        $t('expedientes.dialogs.eliminarBorrador', {
          referencia: currentDraft.idBorrador,
        })
      "
      position="top"
      :visible.sync="displayConfirmation"
      :modal="true"
      :contentStyle="{ overflow: 'visible' }"
      class="modal"
    >
      <p class="m-0">
        {{ $t("expedientes.textos.eliminarBorrador") }}
      </p>
      <template #footer>
        <Button
          :label="$t('common.yes')"
          icon="pi pi-check"
          @click="deleteDraft(currentDraft.idBorrador)"
          autofocus
        />
        <Button
          :label="$t('common.no')"
          icon="pi pi-times"
          @click="displayConfirmation = false"
          class="cancelButton"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import {
  QUERY_BORRADORES,
  MUTATION_DELETE_DRAFT,
} from "@/graphQLQueries/BorradoresQueries";
import { TIPOS_SERVICIO } from "@/resources/constants";
import DatesMixin from "@/utils/dates";
import StringsMixin from "@/utils/strings";
import CurrencyMixin from "@/utils/currency";
import RoutesMixin from "@/utils/routes";
import MessagesMixin from "@/utils/messages";

export const FILTERS_NUMERIC = ["id"];
export const FILTERS_BOOLEAN = ["pagado"];

export default {
  name: "Drafts",
  props: {
    type: {
      type: String,
      default: "reclamacion",
    },
  },
  mixins: [DatesMixin, StringsMixin, CurrencyMixin, RoutesMixin, MessagesMixin],
  data() {
    return {
      sort: ["-id"],
      numPagina: 0,
      tamPagina: 10,
      loading: true,
      displayConfirmation: false,
      reclamacion: TIPOS_SERVICIO.RECLAMACION,
      filters: {},
      drafts: {},
      headerStyle: "text-align: center",
      currentDraft: {},
      dropdownPaid: [
        { name: this.$i18n.t("expedientes.label.pagado"), code: "true" },
        { name: this.$i18n.t("expedientes.label.sinPagar"), code: "false" },
      ],
    };
  },
  apollo: {
    drafts: {
      query: QUERY_BORRADORES,
      variables() {
        return {
          criteria: {
            filter: this.backendFilters,
            page: this.numPagina,
            size: this.tamPagina,
            sort: this.sort,
          },
        };
      },
      fetchPolicy: "no-cache",
      update(data) {
        const drafts = data.listaBorradores;
        this.loading = false;
        return {
          items: drafts.results,
          totalElements: drafts.totalElements,
        };
      },
    },
  },
  computed: {
    backendFilters() {
      var filters2 = [`usuario.uuid~uuid=${this.$store.state.profile.uuid}`];
      filters2.push(`tipo~eq=${this.type}`);
      for (let [key, value] of Object.entries(this.filters)) {
        if (value != null && value != undefined && `${value}`) {
          if (FILTERS_NUMERIC.includes(key)) {
            filters2.push(`${key}~eq=${value}`);
          } else if (FILTERS_BOOLEAN.includes(key)) {
            filters2.push(`${key}~booleanEQ=${value}`);
          } else {
            filters2.push(`${key}~ilike=${value}`);
          }
        }
      }
      return filters2;
    },
  },
  methods: {
    clearFields() {
      this.filters = {};
    },
    search() {
      this.loading = true;

      this.$apollo.queries.drafts.refetch();
    },
    onPage(event) {
      this.numPagina = event.page;
    },
    customSort(event) {
      var sortField = event.sortField;
      var sortOrder = event.sortOrder == -1 ? "-" : "";
      var sortToApply = sortOrder + sortField;
      var sorts = [sortToApply];
      this.sort = sorts;
      this.search();
    },
    openDeleteModal(selectedDraft) {
      this.currentDraft = selectedDraft;
      this.displayConfirmation = true;
    },
    getDraft(productCode) {
      const claimTypes = [
        {
          code: "basic",
          internalValue: "ICIRED_BASICO",
        },
        {
          code: "burofax",
          internalValue: "ICIRED_BUROFAX",
        },
        {
          code: "notarial",
          internalValue: "ICIRED_NOTARIAL",
        },
      ];
      return claimTypes.find((claim) => productCode == claim.internalValue);
    },
    onDraftClick(draft) {
      if (this.type === "reclamacion") {
        this.goToEditDraftView(
          draft.codigoProducto,
          "creditor",
          draft.idBorrador
        );
      } else {
        this.goToConsultaTercerosParam(draft.codigoProducto, draft.idBorrador);
      }
    },
    deleteDraft(id) {
      this.$apollo
        .mutate({
          mutation: MUTATION_DELETE_DRAFT,
          variables: {
            id: id,
          },
        })
        .then(() => {
          this.search();
          this.setMessages(
            "success",
            this.$t("expedientes.messages.success.draftDeleted"),
            3000
          );
        })
        .catch((error) => {
          console.error(error);
          this.setMessages(
            "error",
            this.$t("expedientes.messages.error.draftDeleted"),
            3000
          );
        });
      this.displayConfirmation = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.padding {
  padding: 2%;
}

.botonFiltrar {
  margin-right: 5px;
}

.modal {
  .p-button {
    margin: 0 0.5rem 0 0;
    min-width: 10rem;
  }

  p {
    margin: 0;
  }

  .confirmation-content {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .p-dialog .p-button {
    min-width: 6rem;
  }
}

.column-title {
  color: white;
}

// RESPONSIVE
.p-datatable-responsive .p-datatable-tbody > tr > td .column-title {
  display: none;
}

@media screen and (max-width: 640px) {
  .column-title {
    color: black;
  }
}

@media screen and (max-width: 960px) {
  .centerButton {
    width: 100% !important;
  }
}
</style>